import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DatePickerWrapperComponent } from './date-picker-wrapper.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { CalendarModule } from '@finder/shared/components/calendar/calendar.module';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
        CalendarModule,
    ],
    declarations: [
        DatePickerWrapperComponent,
    ],
    providers: [],
    exports: [
        DatePickerWrapperComponent,
    ],
})
export class DatePickerWrapperModule {}
